/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Layout from '../../components/Layout';
import Title from '../../components/Title';
import Button from '../../components/Button';
import { useMediaQuery } from 'react-responsive';
import { Images } from '../../themes';
import { Container, Span, ButtonContainer, Small, AlertImage } from './styles';
import config from '../../config';

export default function Form() {
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });

  const onSubmit = () => {
    window.open(config.inStationStoreURL);
  };

  return (
    <Layout activeRoute="activate" mapImageOnBackground={!isMobile}>
      <Container>
        <AlertImage id="msTeams" src={Images.icons.alert} />
        <Title>
          There's already one version <br />
          of the InStation app
          <highlight>
            {' '}
            activated <br /> for your company{' '}
          </highlight>
        </Title>
        <br />
        <Span>
          Please click in the link below to join your teammates <br /> at the
          InStation App on Microsoft Teams
        </Span>
        <ButtonContainer>
          <Button
            onClick={onSubmit}
            icon={Images.icons.instation}
            alt="InStation logo"
            text="Go to InStation on Microsoft Teams"
            fullWidth={true}
          />
        </ButtonContainer>
        <Small>We'll meet at InStation!</Small>
      </Container>
    </Layout>
  );
}
